import { CustomComponentSettingsFunction } from "../settings";
import { customFormType } from "../settings/customForm";
import {
	menuComponentType,
	menuLayoutComponent,
} from "../settings/menuItemsComponent";
import landingPages from "./landingPages";

export const customLandingWidgets: {
	name: string;
	key: string;
	media?: string;
	comp: string;
	customComponentSettings?: CustomComponentSettingsFunction;
}[] = [
	{
		name: "Header Section",
		key: "header-section",
		media: "<p style='color: #000000; background-color: #ffffff; font-size: 16px; font-family: 'Open Sans', sans-serif; font-weight: 400; text-align: left;'>Header</p>",
		comp: `
			<div id="i6po" class="gjs-grid-row" data-gjs-droppable="false">
				<div id="itjq" class="gjs-grid-column">
					<div id="iyd2" class="gjs-grid-row">
						<div id="iqjl" class="gjs-grid-column">
							<a id="iucmr" href="/" class="gjs-link-box">
								<div data-type-icon id="irfl3k" class="gjs-icon">
									<img id="ihs4lb" src="https://cdn.pixabay.com/photo/2023/03/06/13/58/brand-7833518_1280.png" width="100" height="40" style="object-fit: contain;"/>
								</div>
							</a>
						</div>
						<div id="iffs" class="gjs-grid-column">
							<div id="it00l" class="gjs-grid-row">
								<div id="irtfd" class="gjs-grid-column">
									<a id="icfyb" href="#feature-section" class="gjs-link">About</a>
									<a href="#feature-section" id="infmy1" class="gjs-link">Features</a>
								</div>
								<div id="icyzp" class="gjs-grid-column">
									<a id="i88iz" href="#testimonial-section" class="gjs-link">Testimonials</a>
								</div>
							</div>
						</div>
						<div id="id7x" class="gjs-grid-column"><a id="i1mew" href="" class="gjs-button">Join Waitlist</a></div>
					</div>
				</div>
			</div>
			${landingPages.styles.content}
		`,
	},
	{
		name: "Nav Menu",
		key: menuComponentType,
		media: `
			<p style="color: #000000; background-color: #ffffff; font-size: 16px; font-family: 'Open Sans', sans-serif; font-weight: 400; text-align: left;">Nav Menu</p>
		`,
		comp: `
			${menuLayoutComponent([
				{
					name: "Analytics",
					url: "#",
					submenu: [
						{
							name: "Google",
							url: "#",
							submenu: [
								{
									name: "Google",
									url: "#",
									submenu: [],
								},
							],
						},
					],
				},
				{
					name: "Marketing",
					url: "#",
					submenu: [
						{
							name: "Google",
							url: "#",
							submenu: [],
						},
						{
							name: "Google",
							url: "#",
							submenu: [],
						},
					],
				},
			])}
		`,
	},
	{
		name: "Hero Section",
		key: "hero-section",
		media: `
			<p style="color: #000000; background-color: #ffffff; font-size: 16px; font-family: 'Open Sans', sans-serif; font-weight: 400; text-align: left;">Hero</p>
		`,
		comp: `
			<div id="irz7b" class="gjs-grid-row" data-gjs-droppable="false">
				<div id="iycz3" class="gjs-grid-column">
					<h1 id="irjua" class="gjs-heading">Insert Hero <span id="i4jn1p" class="gjs-text-blue">text here</span></h1>
					<div id="itndw" class="text-main-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
						tempor incididunt ut labore et dolore magna aliqua.<br/></div><a id="iar3s" class="gjs-button">Join
						Waitlist</a><img id="i3vvs" src="https://images.pexels.com/photos/7078666/pexels-photo-7078666.jpeg?auto=compress&cs=tinysrgb&w=800&dpr=2"/>
				</div>
			</div>
			${landingPages.styles.content}
		`,
	},
	{
		name: "About Section",
		key: "about-section",
		media: `
			<p style="color: #000000; background-color: #ffffff; font-size: 16px; font-family: 'Open Sans', sans-serif; font-weight: 400; text-align: left;">About</p>
		`,
		comp: `
		<div id="feature-section" class="gjs-grid-row" data-gjs-droppable="false">
			<div id="imymf" class="gjs-grid-column">
			<div id="ib541" class="gjs-grid-row">
				<div id="iz8m8" class="gjs-grid-column">
				<h4 id="ij2gh" class="gjs-heading gjs-text-blue">Feature One text</h4>
				<h2 id="ism014" class="gjs-heading">Feature Text</h2>
				<div id="igrx8" class="text-main-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
					eiusmod tempor incididunt ut labore et dolore magna aliqua.</div><a id="iqx3z1" class="gjs-button">Getting
					Started</a>
				</div>
				<div id="iepks" class="gjs-grid-column"><img src="https://images.pexels.com/photos/2121640/pexels-photo-2121640.jpeg?auto=compress&cs=tinysrgb&w=500&dpr=2" id="i466d"/>
				</div>
			</div>
			</div>
		</div>
		${landingPages.styles.content}
		`,
	},
	{
		name: "Features Section",
		key: "features-section",
		media: `
			<p style="color: #000000; background-color: #ffffff; font-size: 16px; font-family: 'Open Sans', sans-serif; font-weight: 400; text-align: left;">Features</p>
		`,
		comp: `
			<div id="ioyxg" class="gjs-grid-row" data-gjs-droppable="false">
				<div id="i8w4i" class="gjs-grid-column">
				<h4 id="ihs4lb" class="gjs-heading gjs-text-blue">More Features</h4>
				<h2 id="iiacm" class="gjs-heading">Put here the text describing why your features are
					<span id="icxfor" class="gjs-text-blue">so amazing</span></h2>
				<div id="ia21sa" class="text-main-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
					tempor incididunt ut labore et dolore magna aliqua.</div>
				<div id="ixzh1" class="gjs-grid-row">
					<div id="ilpi3" class="gjs-grid-column feature-item">
					<div data-type-icon id="ipmqo6" class="gjs-icon gjs-feature-icon"><svg viewBox="0 0 24 24">
						<path
							d="M16 9h3l-5 7m-4-7h4l-2 8M5 9h3l2 7m5-12h2l2 3h-3m-5-3h2l1 3h-4M7 4h2L8 7H5m1-5L2 8l10 14L22 8l-4-6H6z">
						</path>
						</svg></div>
					<h3 id="in9ef" class="gjs-heading">Feature text</h3>
					<div id="i8isa" class="text-main-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
						eiusmod tempor incididunt ut labore et dolore magna aliqua.</div>
					</div>
					<div id="ic57kq" class="gjs-grid-column feature-item">
					<div data-type-icon id="ibdusm" class="gjs-icon gjs-feature-icon"><svg viewBox="0 0 24 24">
						<path
							d="M16 9h3l-5 7m-4-7h4l-2 8M5 9h3l2 7m5-12h2l2 3h-3m-5-3h2l1 3h-4M7 4h2L8 7H5m1-5L2 8l10 14L22 8l-4-6H6z">
						</path>
						</svg></div>
					<h3 id="ica43q" class="gjs-heading">Feature text</h3>
					<div id="ickn3f" class="text-main-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
						eiusmod tempor incididunt ut labore et dolore magna aliqua.</div>
					</div>
					<div id="idv32l" class="gjs-grid-column feature-item">
					<div data-type-icon id="ipmept" class="gjs-icon gjs-feature-icon"><svg viewBox="0 0 24 24">
						<path
							d="M16 9h3l-5 7m-4-7h4l-2 8M5 9h3l2 7m5-12h2l2 3h-3m-5-3h2l1 3h-4M7 4h2L8 7H5m1-5L2 8l10 14L22 8l-4-6H6z">
						</path>
						</svg></div>
					<h3 id="ieu6p6" class="gjs-heading">Feature text</h3>
					<div id="izqkf7" class="text-main-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
						eiusmod tempor incididunt ut labore et dolore magna aliqua.</div>
					</div>
				</div>
				</div>
			</div>
			${landingPages.styles.content}
		`,
	},
	{
		name: "Testimonial Section",
		key: "testimonial-section",
		media: `
			<p style="color: #000000; background-color: #ffffff; font-size: 16px; font-family: 'Open Sans', sans-serif; font-weight: 400; text-align: left;">Testimonials</p>
		`,
		comp: `
			<div id="testimonial-section" class="gjs-grid-row" data-gjs-droppable="false">
				<div id="infwen" class="gjs-grid-column">
				<h2 id="ihap8q" class="gjs-heading">Testimonial section</h2>
				<div id="i6fjjy" class="text-main-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
					tempor incididunt ut labore et dolore magna aliqua.</div>
				<div id="i5k4nf" class="gjs-grid-row">
					<div id="inea73" class="gjs-grid-column testimonial-item">
					<div id="i2d7qp" class="gjs-grid-row">
						<div id="idva29" class="gjs-grid-column"><img src="https://source.unsplash.com/random/200x200/?profile,person,business" id="ia7pcr"/>
						</div>
						<div id="i4djop" class="gjs-grid-column">
						<h4 id="iqroa4" class="gjs-heading">Full name</h4>
						<div id="iaqf2c" class="text-main-content">Role / Company</div>
						</div>
					</div>
					<div id="it3yug" class="text-main-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
						eiusmod tempor incididunt ut labore et dolore magna aliqua.</div>
					</div>
					<div id="idndjn" class="gjs-grid-column testimonial-item">
					<div id="ish0zj" class="gjs-grid-row">
						<div id="inucqu" class="gjs-grid-column"><img src="https://source.unsplash.com/random/200x200/?profile,person,business" id="ixzdlj"/>
						</div>
						<div id="iuk8ib" class="gjs-grid-column">
						<h4 id="i04ztt" class="gjs-heading">Full name</h4>
						<div id="ia9ts3" class="text-main-content">Role / Company</div>
						</div>
					</div>
					<div id="i8gt4n" class="text-main-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
						eiusmod tempor incididunt ut labore et dolore magna aliqua.</div>
					</div>
				</div>
				</div>
			</div>
			${landingPages.styles.content}
		`,
	},
	{
		name: "Form",
		key: customFormType,
		media: `
			<p style="color: #000000; background-color: #ffffff; font-size: 16px; font-family: 'Open Sans', sans-serif; font-weight: 400; text-align: left;">Form</p>
		`,
		comp: `
			<div id="${customFormType}" class="mx-auto py-4 text-center text-lg font-semibold" data-gjs-droppable="false">
				Click here to select a form preset
			</div>
		`,
	},
	{
		name: "FAQ Section",
		key: "faq-section",
		media: `
			<p style="color: #000000; background-color: #ffffff; font-size: 16px; font-family: 'Open Sans', sans-serif; font-weight: 400; text-align: left;">FAQ</p>
		`,
		comp: `
			<div className="container" data-gjs-droppable="false">
				<div class="max-w-4xl mx-auto py-6">
                    <!-- Header -->
                    <div class="text-center mb-12 px-4 sm:px-6 lg:px-8">
                        <h1 class="text-4xl font-bold text-gray-900 mb-4">
                            Frequently Asked Questions
                        </h1>
                        <p class="text-lg text-gray-600 max-w-2xl mx-auto">
                            Find answers to the most common questions about our services and platform.
                        </p>
                    </div>

                    <!-- FAQ Accordion -->
                    <div class="bg-white rounded-lg shadow-lg overflow-hidden">
                        <!-- FAQ Item 1 -->
                        <div class="border-b border-gray-200 px-4 sm:px-6 lg:px-8">
                            <input type="checkbox" id="faq-1" class="accordion-checkbox hidden peer">
                            <label 
                                for="faq-1" 
                                class="accordion-label w-full px-6 py-5 flex justify-between items-center cursor-pointer hover:bg-gray-50 transition-colors duration-200"
                            >
                                <span class="text-lg font-semibold text-gray-900 pr-4">
                                    What is your refund policy?
                                </span>
                                <svg 
                                    class="accordion-icon w-5 h-5 text-gray-500 transition-transform duration-300 flex-shrink-0" 
                                    fill="none" 
                                    stroke="currentColor" 
                                    viewBox="0 0 24 24"
                                >
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                                </svg>
                            </label>
                            <div class="accordion-content px-6">
                                <div class="text-gray-600 leading-relaxed">
                                    We offer a 30-day money-back guarantee for all our services. If you're not completely satisfied with your purchase, you can request a full refund within 30 days of your initial payment. To initiate a refund, simply contact our customer support team with your order details.
                                </div>
                            </div>
                        </div>

                        <!-- FAQ Item 2 -->
                        <div class="border-b border-gray-200 px-4 sm:px-6 lg:px-8">
                            <input type="checkbox" id="faq-2" class="accordion-checkbox hidden peer">
                            <label 
                                for="faq-2" 
                                class="accordion-label w-full px-6 py-5 flex justify-between items-center cursor-pointer hover:bg-gray-50 transition-colors duration-200"
                            >
                                <span class="text-lg font-semibold text-gray-900 pr-4">
                                    How do I get started with your platform?
                                </span>
                                <svg 
                                    class="accordion-icon w-5 h-5 text-gray-500 transition-transform duration-300 flex-shrink-0" 
                                    fill="none" 
                                    stroke="currentColor" 
                                    viewBox="0 0 24 24"
                                >
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                                </svg>
                            </label>
                            <div class="accordion-content px-6">
                                <div class="text-gray-600 leading-relaxed">
                                    Getting started is easy! Simply sign up for an account on our website, choose your preferred plan, and follow our onboarding guide. We also provide comprehensive documentation and video tutorials to help you make the most of our platform. Our support team is available 24/7 to assist you during the setup process.
                                </div>
                            </div>
                        </div>

                        <!-- FAQ Item 3 -->
                        <div class="border-b border-gray-200 px-4 sm:px-6 lg:px-8">
                            <input type="checkbox" id="faq-3" class="accordion-checkbox hidden peer">
                            <label 
                                for="faq-3" 
                                class="accordion-label w-full px-6 py-5 flex justify-between items-center cursor-pointer hover:bg-gray-50 transition-colors duration-200"
                            >
                                <span class="text-lg font-semibold text-gray-900 pr-4">
                                    What payment methods do you accept?
                                </span>
                                <svg 
                                    class="accordion-icon w-5 h-5 text-gray-500 transition-transform duration-300 flex-shrink-0" 
                                    fill="none" 
                                    stroke="currentColor" 
                                    viewBox="0 0 24 24"
                                >
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                                </svg>
                            </label>
                            <div class="accordion-content accordion-content-dev px-6">
                                <div class="text-gray-600 leading-relaxed">
                                    We accept all major credit cards (Visa, MasterCard, American Express), PayPal, and bank transfers. For enterprise customers, we also offer invoice-based billing with NET-30 payment terms. All transactions are processed securely using industry-standard encryption.
                                </div>
                            </div>
                        </div>

                        <!-- FAQ Item 4 -->
                        <div class="border-b border-gray-200 px-4 sm:px-6 lg:px-8">
                            <input type="checkbox" id="faq-4" class="accordion-checkbox hidden peer">
                            <label 
                                for="faq-4" 
                                class="accordion-label w-full px-6 py-5 flex justify-between items-center cursor-pointer hover:bg-gray-50 transition-colors duration-200"
                            >
                                <span class="text-lg font-semibold text-gray-900 pr-4">
                                    What payment methods do you accept?
                                </span>
                                <svg 
                                    class="accordion-icon w-5 h-5 text-gray-500 transition-transform duration-300 flex-shrink-0" 
                                    fill="none" 
                                    stroke="currentColor" 
                                    viewBox="0 0 24 24"
                                >
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                                </svg>
                            </label>
                            <div class="accordion-content accordion-content-dev px-6">
                                <div class="text-gray-600 leading-relaxed">
                                    We accept all major credit cards (Visa, MasterCard, American Express), PayPal, and bank transfers. For enterprise customers, we also offer invoice-based billing with NET-30 payment terms. All transactions are processed securely using industry-standard encryption.
                                </div>
                            </div>
                        </div>

                        <!-- FAQ Item 5 -->
                        <div class="border-b border-gray-200 px-4 sm:px-6 lg:px-8">
                            <input type="checkbox" id="faq-5" class="accordion-checkbox hidden peer">
                            <label 
                                for="faq-5" 
                                class="accordion-label w-full px-6 py-5 flex justify-between items-center cursor-pointer hover:bg-gray-50 transition-colors duration-200"
                            >
                                <span class="text-lg font-semibold text-gray-900 pr-4">
                                    What payment methods do you accept?
                                </span>
                                <svg 
                                    class="accordion-icon w-5 h-5 text-gray-500 transition-transform duration-300 flex-shrink-0" 
                                    fill="none" 
                                    stroke="currentColor" 
                                    viewBox="0 0 24 24"
                                >
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                                </svg>
                            </label>
                            <div class="accordion-content accordion-content-dev px-6">
                                <div class="text-gray-600 leading-relaxed">
                                    We accept all major credit cards (Visa, MasterCard, American Express), PayPal, and bank transfers. For enterprise customers, we also offer invoice-based billing with NET-30 payment terms. All transactions are processed securely using industry-standard encryption.
                                </div>
                            </div>
                        </div>

                        <!-- FAQ Item 6 -->
                        <div class="border-b border-gray-200 px-4 sm:px-6 lg:px-8">
                            <input type="checkbox" id="faq-6" class="accordion-checkbox hidden peer">
                            <label 
                                for="faq-6" 
                                class="accordion-label w-full px-6 py-5 flex justify-between items-center cursor-pointer hover:bg-gray-50 transition-colors duration-200"
                            >
                                <span class="text-lg font-semibold text-gray-900 pr-4">
                                    What payment methods do you accept?
                                </span>
                                <svg 
                                    class="accordion-icon w-5 h-5 text-gray-500 transition-transform duration-300 flex-shrink-0" 
                                    fill="none" 
                                    stroke="currentColor" 
                                    viewBox="0 0 24 24"
                                >
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                                </svg>
                            </label>
                            <div class="accordion-content accordion-content-dev px-6">
                                <div class="text-gray-600 leading-relaxed">
                                    We accept all major credit cards (Visa, MasterCard, American Express), PayPal, and bank transfers. For enterprise customers, we also offer invoice-based billing with NET-30 payment terms. All transactions are processed securely using industry-standard encryption.
                                </div>
                            </div>
                        </div>
                </div>
			</div>
			<style>
				.accordion-content {
                    max-height: 500px;
                    padding-top: 0;
                    padding-bottom: 1.25rem;
                    overflow: hidden;
                    transition: max-height 0.3s ease-out, padding 0.3s ease-out;
                }
                .accordion-checkbox:checked + .accordion-label + .accordion-content {
                    max-height: 0;
                    padding-top: 0;
                    padding-bottom: 0;
                }
                .accordion-checkbox:checked + .accordion-label .accordion-icon {
                    transform: rotate(180deg);
                }
			</style>
		`,
	},
	{
		name: "Bullets Section",
		key: "bullets-section",
		media: `
			<p style="color: #000000; background-color: #ffffff; font-size: 16px; font-family: 'Open Sans', sans-serif; font-weight: 400; text-align: left;">Bullets</p>
		`,
		comp: `
			<div class="bullet-point-section" data-gjs-droppable="false">
				<h2>How different running a business would be if you could:</h2>
				<ul>
					<li>
					<span class="icon">✔</span>
					<span class="text">
						<strong>CONFIDENTLY</strong> create & launch your website in less than a week and know exactly what to do if you run into a problem with Squarespace
					</span>
					</li>
					<li>
					<span class="icon">✔</span>
					<span class="text">
						<strong>LAUNCHING</strong> new offers, blogging, updating your site easily by changing colors, fonts & graphics without frustration
					</span>
					</li>
					<li>
					<span class="icon">✔</span>
					<span class="text">
						Saving a lot of <strong>TIME</strong> that you can now spend on doing actual work that brings you sales and clients
					</span>
					</li>
					<li>
					<span class="icon">✔</span>
					<span class="text">
						Adding Squarespace design <strong>SERVICES</strong> to your business toolkit and helping others launch gorgeous websites?
					</span>
					</li>
				</ul>
			</div>
			<style>
			.bullet-point-section {
			font-family: 'Arial', sans-serif;
			line-height: 1.6;
			color: #333;
			padding: 20px;
			border-radius: 8px;
			max-width: 800px;
			margin: 0 auto;
			}

			.bullet-point-section h2 {
			font-size: 24px;
			color: #111;
			margin-bottom: 15px;
			}

			.bullet-point-section ul {
			list-style: none;
			padding: 0;
			}

			.bullet-point-section li {
			display: flex;
			align-items: flex-start;
			margin-bottom: 15px;
			}

			.bullet-point-section .icon {
			color: #f1c40f;
			font-size: 18px;
			margin-right: 10px;
			flex-shrink: 0;
			}

			.bullet-point-section .text {
			font-size: 16px;
			color: #333;
			}

			.bullet-point-section .text strong {
			color: #000;
			}

			</style>
		`,
	},
	{
		name: "Call to Action Section",
		key: "call-to-action-section",
		media: `
			<p style="color: #000000; background-color: #ffffff; font-size: 16px; font-family: 'Open Sans', sans-serif; font-weight: 400; text-align: left;">CtA</p>
		`,
		comp: `
		<div id="iz29ek" class="gjs-grid-row" data-gjs-droppable="false">
    <div id="ik2rdi" class="gjs-grid-column" data-gjs-draggable="false" data-gjs-selectable="false">
      <h2 id="i83vu9" class="gjs-heading" data-gjs-draggable="false">Put here your description <br/>for
        <span id="i7owfh" class="gjs-text-blue" data-gjs-draggable="false">this section</span></h2>
      <div id="in201n" class="text-main-content" data-gjs-draggable="false" data-gjs-selectable="false">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua.<br/></div><a id="iwgwt5" class="gjs-button">Join
        Waitlist</a>
    </div>
  </div>
  ${landingPages.styles.content}
		`,
	},
	{
		name: "Checkout Section",
		key: "checkout-section",
		media: `
			<p style="color: #000000; background-color: #ffffff; font-size: 16px; font-family: 'Open Sans', sans-serif; font-weight: 400; text-align: left;">Checkout</p>
		`,
		comp: `
			<div id="i7jz" class="gjs-grid-row" data-gjs-droppable="false">
				<div id="i6d6" class="gjs-grid-column" style="height: 60px; background-color: #f1f1f1; padding: 20px; display: flex; align-items: center; justify-content: center;">
				<h2 id="i6v3" class="gjs-heading">Checkout Section</h2>				
			</div>
			${landingPages.styles.content}
		`,
	},
	{
		name: "Footer Section",
		key: "footer-section",
		media: `
			<p style="color: #000000; background-color: #ffffff; font-size: 16px; font-family: 'Open Sans', sans-serif; font-weight: 400; text-align: left;">Footer</p>
		`,
		comp: `
			<div id="iv3be5" class="gjs-grid-row" data-gjs-droppable="false">
				<div id="ilriti" class="gjs-grid-column">
				<div id="im0rle" class="gjs-grid-row">
					<div id="iotp6j" class="gjs-grid-column"><a href="/" id="iih6cv" class="gjs-link-box">
						<div data-type-icon id="ip6zoj" class="gjs-icon">
						<img id="ihs4lb" src="https://cdn.pixabay.com/photo/2023/03/06/13/58/brand-7833518_1280.png" width="100" height="40" style="object-fit: contain;"/>
						</div>
					</a></div>
					<div id="i1hx7l" class="gjs-grid-column"><a id="ij7g8t" title="" href="##" class="gjs-link">Pricing<br/></a><a
						id="ipjdtn" href="##" class="gjs-link">Terms &amp; Conditions<br/></a><a id="ikj01e" href="##"
						class="gjs-link">Refund Policy<br/></a><a id="i2sl68" href="##" class="gjs-link">Contact Us<br/></a></div>
				</div>
				<div id="it6g1v" class="gjs-text-blue">Copyright © YEAR Company name</div>
				</div>
			</div>
			${landingPages.styles.content}
		`,
	},
];

export default function () {
	return <></>;
}
